const carData = {
  manufacturer: [
    "acura",
    "alfa-romeo",
    "aston-martin",
    "audi",
    "bmw",
    "buick",
    "cadillac",
    "chevrolet",
    "chrysler",
    "datsun",
    "dodge",
    "ferrari",
    "fiat",
    "ford",
    "gmc",
    "harley-davidson",
    "honda",
    "hyundai",
    "infiniti",
    "jaguar",
    "jeep",
    "kia",
    "land rover",
    "lexus",
    "lincoln",
    "mazda",
    "mercedes-benz",
    "mercury",
    "mini",
    "mitsubishi",
    "nissan",
    "pontiac",
    "porsche",
    "ram",
    "rover",
    "saturn",
    "subaru",
    "tesla",
    "toyota",
    "volkswagen",
    "volvo",
  ],
  condition: ["excellent", "fair", "good", "like new", "new", "salvage"],
  cylinders: [
    "10 cylinders",
    "12 cylinders",
    "3 cylinders",
    "4 cylinders",
    "5 cylinders",
    "6 cylinders",
    "8 cylinders",
    "other",
  ],
  fuel: ["diesel", "electric", "gas", "hybrid", "other"],
  transmission: ["automatic", "manual", "other"],
  drive: ["4wd", "fwd", "rwd"],
  type: [
    "SUV",
    "bus",
    "convertible",
    "coupe",
    "hatchback",
    "mini-van",
    "offroad",
    "other",
    "pickup",
    "sedan",
    "truck",
    "van",
    "wagon",
  ],
  paint_color: [
    "black",
    "blue",
    "brown",
    "custom",
    "green",
    "grey",
    "orange",
    "purple",
    "red",
    "silver",
    "white",
    "yellow",
  ],
};

export default carData;
